export const VITRINE_B2B_LIST_PATH = "/admin/visualizar-vitrines-b2b";
export const VITRINE_B2B_CREATE_PATH = "/admin/criar-vitrine-b2b";

export function vitrineB2bEditPath(id) {
  return `/admin/editar-vitrine-b2b/${id}`;
}
